var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAttechment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.74763L10 17.3276C10 19.4176 8.47 21.2776 6.39 21.4776C4.01 21.7076 2 19.8376 2 17.4976L2 5.13763C2 3.82763 2.94 2.63763 4.24 2.50763C5.74 2.35763 7 3.52763 7 4.99763L7 15.4976C7 16.0476 6.55 16.4976 6 16.4976C5.45 16.4976 5 16.0476 5 15.4976L5 6.74763C5 6.33763 4.66 5.99763 4.25 5.99763C3.84 5.99763 3.5 6.33763 3.5 6.74763L3.5 15.3576C3.5 16.6676 4.44 17.8576 5.74 17.9876C7.24 18.1376 8.5 16.9676 8.5 15.4976L8.5 5.16763C8.5 3.07763 6.97 1.21763 4.89 1.01763C2.5 0.787628 0.499999 2.65763 0.499999 4.99763L0.5 17.2676C0.5 20.1376 2.6 22.7076 5.46 22.9776C8.75 23.2776 11.5 20.7176 11.5 17.4976L11.5 6.74763C11.5 6.33763 11.16 5.99763 10.75 5.99763C10.34 5.99763 10 6.33763 10 6.74763Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttechment);
export default __webpack_public_path__ + "static/media/fileAttechment.4b5887a8.svg";
export { ForwardRef as ReactComponent };